import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';

import React from 'react';
import {useTranslation} from 'react-i18next';
import {Text} from '../../../utils/style/texts';
import SlideUpTransition from '../../SlideUpTransition';
import TextButton from '../../Controls/TextButton';
import Dialog from '../../Dialog';
import {Flex} from "../../Container/Flex";


const ConfirmDialog = props => {
    const [t] = useTranslation();

    const {open, title, text, onConfirm, cancelText, onCancel, onReject, confirmText, rejectText, other} = props;
    return (
        <Dialog
            {...other}
            open={!!open}
            onError={{
                catch: reset => {
                    if (onCancel) {
                        onCancel();
                        reset();
                    }
                }
            }}
            TransitionComponent={SlideUpTransition}
            onClose={() => {
                if (onCancel) onCancel();
            }}>
            {title && (
                <DialogTitle>{title}</DialogTitle>
            )}
            <DialogContent style={{minWidth: 400}}>
                <Flex fullWidth style={{paddingTop: 24}}>
                    <Text style={{width: '100%'}}>
                        {text}
                    </Text>
                </Flex>
            </DialogContent>
            <DialogActions>
                {(!!onCancel || !!cancelText) && (
                    <TextButton onClick={() => onCancel && onCancel()}>
                        {cancelText || t('cancel')}
                    </TextButton>
                )}
                {(!!onReject || !!rejectText) && (
                    <TextButton onClick={() => onReject && onReject()}>
                        {rejectText || t('no')}
                    </TextButton>
                )}
                <TextButton onClick={() => onConfirm()} color="primary">
                    {confirmText || t('confirm')}
                </TextButton>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmDialog;